import { detect } from "detect-browser";
import compareVersions from "compare-versions";
import { configs } from "./configs";
import { scaleLinear } from "d3-scale";


export const mapRange = (val, in_min, in_max, out_min, out_max) => {
  return (val - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
};

export const randomInt = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const getClosestPoint = (val, min, step) => {
  const closestStep = Math.round((val - min) / step) * step + min;
  return val + (closestStep - val)
};

export const interpolateRgb = scaleLinear()
      .domain([0, 50, 100])
      .range(configs.sliderColors);


export const applyColorToSvgShape = (shape, color) => {
  const shapeStyle = getComputedStyle(shape);
  if (shapeStyle.stroke !== "none") {
    shape.style.stroke = color
  }
  if (shapeStyle.fill !== "none") {
    shape.style.fill = color
  }
};


export const changeShapesColorInNode = (node, color, excludeShapes = []) => {
  const shapeQuery =
      ["circle","path","polygon","polyline","line", "rect"]
      .filter(s => excludeShapes.indexOf(s) === -1).join(",");

  [].slice
      .call(node.querySelectorAll(shapeQuery))
      .forEach(shape => {
        applyColorToSvgShape(shape, color)
      })
};

export const detectBrowser = () => {
  const { supportedVersions } = configs;

  if (typeof document !== "undefined") {
    try {
      const browserInfo = detect();
      if (browserInfo) {
        const supportedVersion = supportedVersions[browserInfo.name];
        let isSupported = true;

        if (!supportedVersion || typeof supportedVersion === "undefined") {
          isSupported = false;
        } else {
          isSupported =
              compareVersions(browserInfo.version, supportedVersion) >= 0;
        }

        return {
          ...browserInfo,
          isSupported,
          supportedVersion
        };
      }
    } catch (err) {
      // console.error(err);
    }
  }

  return null;
};


export function loadJson(url) {
  return fetch(url).then(response => {
        return response.json().catch(e => {
          console.error(`failed to parse ${url}`);
          throw e;
        })
      }
  );
}


export const createIconUrl = (staticContentRecord) => `icons/${staticContentRecord.prop_key}.svg`;



// WEBPACK FOOTER //
// ./src/utils.js